import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { UiImageAtomComponent } from '../../atoms/ui-image/ui-image.component';
import { UiSponsorBadgeAtomComponent, UiSponsorBadgeVariant, UiSponsorBadgeLayout } from '../../atoms/ui-sponsor-badge/ui-sponsor-badge.component';

@Component({
  selector: 'app-offer-media',
  imports: [UiImageAtomComponent, UiSponsorBadgeAtomComponent],
  template: `
    @if (showBadge()) {
      <app-ui-sponsor-badge
        [variant]="badgeVariant()"
        [layout]="badgeLayout()"
        [label]="badgeLabel()"
        [icon]="badgeIcon()"
         />
    }
    <div class="offer-media__logo"
         [class.offer-media__logo--tc]="variant() === 'tc'"
         [class.offer-media__logo--detail]="variant() === 'detail'"
         [class.offer-media__logo--portrait]="isPortrait()">
      <app-ui-image
        [src]="logoUrl()"
        [alt]="companyName()"
        [cssClass]="imgClass()"
        (imageLoaded)="isPortrait.set($event.height > $event.width)" />
    </div>
  `,
  styleUrl: './offer-media.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferMediaMoleculeComponent {
  readonly logoUrl     = input.required<string>();
  readonly companyName = input.required<string>();
  readonly productName = input('');
  readonly imgClass    = input('');

  readonly showBadge    = input(false);
  readonly badgeVariant = input<UiSponsorBadgeVariant>('blue');
  readonly badgeLayout  = input<UiSponsorBadgeLayout>('default');
  readonly badgeLabel   = input('');
  readonly badgeIcon    = input('');
  // 'card' = 134.5×35px; 'tc' = 134.5×85px (logos verticales TC); 'detail' = 150×80px
  readonly variant      = input<'card' | 'tc' | 'detail'>('card');

  // true cuando el logo/imagen es vertical (alto > ancho); ver .offer-media__logo--portrait
  protected readonly isPortrait = signal(false);
}
